<template lang="pug">
.production-tool-contracting-form
	form(@submit.prevent="send")
		h3.sf-heading-2.page-subtitle(ref="ptc-title", tabindex="-1") Vállalkozás adatai
		.form-row(:class="{ 'has-error': $v.model.companyName.$dirty && $v.model.companyName.$invalid }")
			.form-col
				label#ptc-company-name-label(for="ptc-company-name-input") Cég, vállalkozás neve
			.form-col
				VueInput#ptc-company-name-input(v-model="model.companyName", :max-width="352", :max-length="50", :has-error="$v.model.companyName.$dirty && $v.model.companyName.$invalid", @blur="$v.model.companyName.$touch()", aria-describedby="ptc-company-name-error")
				VueErrorMessage#ptc-company-name-error(v-if="$v.model.companyName.$dirty && !$v.model.companyName.required", position="bottom") Kérjük, adja meg az ajánlatot kérő cég, vállalkozás nevét!
		.form-row(:class="{ 'has-error': $v.model.zipCode.$dirty && $v.model.zipCode.$invalid }")
			.form-col
				label#ptc-zip-code-label(for="ptc-zip-code-input") Irányítószám
			.form-col
				VueSettlementSelector#ptc-zip-code-input(v-model="address", :settlements="settlements", @zip-change="getSettlements", @input="$v.model.zipCode.$touch(); $v.model.settlement.$touch()", :has-error="$v.model.zipCode.$dirty && $v.model.zipCode.$invalid", aria-describedby="ptc-zip-code-error")
				VueErrorMessage#ptc-zip-code-error(v-if="$v.model.zipCode.$dirty && !$v.model.zipCode.required", position="bottom") Kérjük, adja meg irányítószámát!
				VueErrorMessage#ptc-zip-code-error(v-if="$v.model.zipCode.$dirty && !$v.model.zipCode.pattern", position="bottom") Kérjük ellenőrizze az irányítószámot!
				VueErrorMessage#ptc-zip-code-error(v-if="$v.model.zipCode.$dirty && !$v.model.settlement.required && !$v.model.zipCode.$invalid", position="bottom") Ehhez az irányítószámhoz nem tartozik település Magyarországon. Kérjük, próbálja meg újra beírni az irányítószámot!
		.form-row(:class="{ 'has-error': $v.model.yearlyIncome.$dirty && $v.model.yearlyIncome.$invalid }")
			.form-col
				label#ptc-yearly-income-label(for="ptc-yearly-income-select") Nettó éves árbevétel
			.form-col
				VueSelect#ptc-yearly-income-select(label-id="ptc-yearly-income-label", v-model="model.yearlyIncome", :max-width="178", placeholder="Kérjük, válasszon!", @input="$v.model.yearlyIncome.$touch()", :has-error="$v.model.yearlyIncome.$dirty && $v.model.yearlyIncome.$invalid", aria-describedby="ptc-yearly-income-error")
					VueSelectOption(v-for="(item, index) in yearlyIncome", :value="item.key", :text="item.value", :key="item.key", :index="index", :label-id="`ptc-yearly-income-select-item-${index}`")
				VueErrorMessage#ptc-yearly-income-error(v-if="$v.model.yearlyIncome.$dirty && !$v.model.yearlyIncome.required", position="bottom") Kérjük, válassza ki a cég, vállalkozás nettó éves árbevételét!
		.form-row(:class="{ 'has-error': $v.model.taxNumber.$dirty && $v.model.taxNumber.$invalid }")
			.form-col
				label#ptc-tax-number-label(for="ptc-tax-number-input") Adószáma
			.form-col
				VueMaskedInput#ptc-tax-number-input(v-model="model.taxNumber", :mask="'########-#-##'", :max-width="176", :max-length="50", :has-error="$v.model.taxNumber.$dirty && $v.model.taxNumber.$invalid", @blur="$v.model.taxNumber.$touch()", aria-describedby="ptc-tax-number-error")
				VueErrorMessage#ptc-tax-number-error(v-if="$v.model.taxNumber.$dirty && !$v.model.taxNumber.required", position="bottom") Kérjük, adja meg a cég, vállalkozás adószámát!
				VueErrorMessage#ptc-tax-number-error(v-if="$v.model.taxNumber.$dirty && !$v.model.taxNumber.pattern", position="bottom") Kérjük, ellenőrizze az adószámot!
		h3.sf-heading-2.page-subtitle(ref="ptc-title", tabindex="-1") Kapcsolattartó adatai
		.form-row(:class="{ 'has-error': $v.model.contactName.$dirty && $v.model.contactName.$invalid }")
			.form-col
				label#ptc-contact-name-label(for="ptc-contact-name-input") Kapcsolattartó neve
			.form-col
				VueInput#ptc-contact-name-input(v-model="model.contactName", :max-width="352", :max-length="50", :has-error="$v.model.contactName.$dirty && $v.model.contactName.$invalid", @blur="$v.model.contactName.$touch()", aria-describedby="ptc-contact-name-error")
				VueErrorMessage#ptc-contact-name-error(v-if="$v.model.contactName.$dirty && !$v.model.contactName.required", position="bottom") Kérjük, adja meg a kapcsolattartó nevét!
		.form-row(:class="{ 'has-error': $v.model.contactMobilePhone.$dirty && $v.model.contactMobilePhone.$invalid }")
			.form-col
				label#ptc-contact-mobile-phone-label(for="ptc-contact-mobile-phone-input") Mobiltelefonszáma
			.form-col
				VueMobilephoneInput#ptc-contact-mobile-phone-input(v-model="model.contactMobilePhone", :max-width="176", prefix="+36", addon="pl.: +36 XX 123 4567", @blur="$v.model.contactMobilePhone.$touch()", :has-error="$v.model.contactMobilePhone.$dirty && $v.model.contactMobilePhone.$invalid", aria-describedby="ptc-contact-mobile-phone-error")
				VueErrorMessage#ptc-contact-mobile-phone-error(v-if="$v.model.contactMobilePhone.$dirty && !$v.model.contactMobilePhone.required", position="bottom") Kérjük, adja meg a kapcsolattartó mobiltelefonszámát!
				VueErrorMessage#ptc-contact-mobile-phone-error(v-if="$v.model.contactMobilePhone.$dirty && !$v.model.contactMobilePhone.pattern", position="bottom") Kérjük ellenőrizze a mobiltelefonszámot.
		.form-row(:class="{ 'has-error': $v.model.contactEmail.$dirty && $v.model.contactEmail.$invalid }")
			.form-col
				label#ptc-contact-email-label(for="ptc-contact-email-input") E-mail címe
			.form-col
				VueInput#ptc-contact-email-input(v-model="model.contactEmail", :max-width="352", :max-length="50", :has-error="$v.model.contactEmail.$dirty && $v.model.contactEmail.$invalid", @blur="$v.model.contactEmail.$touch()", aria-describedby="ptc-contact-email-error")
				VueErrorMessage#ptc-contact-email-error(v-if="$v.model.contactEmail.$dirty && !$v.model.contactEmail.required", position="bottom") Kérjük, adja meg a kapcsolattartó e-mail címét!
				VueErrorMessage#ptc-contact-email-error(v-if="$v.model.contactEmail.$dirty && !$v.model.contactEmail.email", position="bottom") Kérjük, ellenőrizze az e-mail címet!
		h3.sf-heading-2.page-subtitle(ref="ptc-title", tabindex="-1") Finanszírozás adatai
		.form-row(:class="{ 'has-error': $v.model.instrument.$dirty && $v.model.instrument.$invalid }")
			.form-col
				label#ptc-instrument-label(for="ptc-instrument-select") Finanszírozandó eszköz
			.form-col
				VueSelect#ptc-instrument-select(v-model="model.instrument", label-id="ptc-instrument-label", :max-width="352", placeholder="Kérjük, válasszon!", @input="$v.model.instrument.$touch()", :has-error="$v.model.instrument.$dirty && $v.model.instrument.$invalid", aria-describedby="ptc-instrument-error")
					VueSelectOption(v-for="(item, index) in instrument", :value="item.key", :text="item.value", :key="item.key", :index="index", :label-id="`ptc-instrument-select-item-${index}`")
				VueErrorMessage#ptc-instrument-error(v-if="$v.model.instrument.$dirty && !$v.model.instrument.required", position="bottom") Kérjük, válassza ki a finanszírozandó eszköz típusát!
		.form-row
			.form-col
				label#ptc-note-label(for="ptc-note-input") Megjegyzés (opcionális)
				VueTextarea#ptc-note-input(v-model="model.note", :max-width="736", :max-length="800", :min-line-number="5", :max-line-number="5", :has-counter="true")
		.form-row(v-if="captchaImg", :class="{ 'has-error': ($v.model.captchaText.$dirty && $v.model.captchaText.$invalid) || captchaError }")
			.form-col
				label#ptc-captcha-label(for="ptc-captcha-input") Írja be a képen látható kódot
			.form-col
				VueCaptcha#ptc-captcha-input(:img="'data:image/png;base64,' + captchaImg", v-model="model.captchaText", :max-width="104", @keyup="$emit('captcha-keyup')", @blur="$v.model.captchaText.$touch()", :has-error="($v.model.captchaText.$dirty && $v.model.captchaText.$invalid) || captchaError", aria-describedby="ptc-captcha-error")
				VueErrorMessage#ptc-captcha-error(v-if="$v.model.captchaText.$dirty && !$v.model.captchaText.required", position="bottom") Kérjük, adja meg a képen látható kódot!
				VueErrorMessage#ptc-captcha-error(v-if="captchaError", position="bottom") Kérjük, ellenőrizze a képen látható kódot!
		hr
		.form-row(:class="{ 'has-error': $v.model.acceptPrivacyStatement.$dirty && $v.model.acceptPrivacyStatement.$invalid }")
			VueCheckbox#ptc-accept-privacy-statement-checkbox(v-model="model.acceptPrivacyStatement", @blur="$v.model.acceptPrivacyStatement.$touch()", :has-error="$v.model.acceptPrivacyStatement.$dirty && $v.model.acceptPrivacyStatement.$invalid", aria-describedby="ptc-accept-privacy-statement-error")
				slot Nyilatkozom, hogy a Merkantil Bank Zrt. #[a.link(href="/static/merkantil/sw/file/MERKANTIL_BANK_GDPR_AAT.pdf", target="_blank", rel="noopener noreferrer") Általános adatvédelmi tájékoztatóját] és a #[a.link(href="/static/merkantil/sw/file/BANK_Finanszirozas_Adatkezelesi_tajekoztato.pdf", target="_blank", rel="noopener noreferrer") Finanszírozási szerződésekre vonatkozó adatkezelési tájékoztatót] elolvastam, tudomásul vettem és hozzájárulok adataim kezeléséhez az ajánlatadás és a szerződés előkészítése során végzett kapcsolattartás érdekében.
			VueErrorMessage#ptc-accept-privacy-statement-error(v-if="$v.model.acceptPrivacyStatement.$dirty && !$v.model.acceptPrivacyStatement.checked", position="bottom") Kérjük olvassa el és fogadja el az adatvédelmi tájékoztatókat!
		.form-row
			.form-col
				VueButton(ref="button", :disabled="sending") Ajánlatot kérek
</template>

<script>
import VueButton from '@ui-common/vue-button';
import VueCaptcha from '@ui-common/vue-captcha';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueInput from '@ui-common/vue-input';
import VueMaskedInput from '@ui-common/vue-masked-input';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import VueRadioGroup from '@ui-common/vue-radio-group';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueSettlementSelector from '@ui-common/vue-settlement-selector';
import VueTextarea from '@ui-common/vue-textarea';
import VueTooltip from '@ui-common/vue-tooltip';
import { required, email } from 'vuelidate/lib/validators';
import pattern from '../../../common/js/validators/pattern';
import { jumpToFirstError } from '../../../common/js/find-first-error-component/find-first-error-component';
import { ZIP_CODE_REGEXP, TAX_NUMBER_REGEXP, MOBILE_PHONE_REGEXP } from '../../../common/js/constants/constants';
export default {
	mixins: [jumpToFirstError],
	data: () => ({
		model: {
			companyName: null,
			zipCode: null,
			settlement: null,
			yearlyIncome: null,
			taxNumber: null,
			contactName: null,
			contactMobilePhone: null,
			contactEmail: null,
			instrument: null,
			note: null,
			captchaText: null,
			acceptPrivacyStatement: null
		},
		address: null
	}),
	props: {
		settlements: {
			required: true
		},
		yearlyIncome: {
			required: true
		},
		instrument: {
			required: true
		},
		captchaImg: {
			required: true
		},
		captchaError: {
			required: true
		},
		sending: {
			required: true
		}
	},
	watch: {
		address(val) {
			if (val) {
				this.model.zipCode = val.zipCode;
				this.model.settlement = val.settlement;
			}
		},
		captchaError(val) {
			if (val) {
				this.$nextTick(() => {
					this.jumpToFirstError();
				});
			}
		}
	},
	validations() {
		return {
			model: {
				companyName: {
					required
				},
				zipCode: {
					required,
					pattern: pattern(ZIP_CODE_REGEXP)
				},
				settlement: {
					required
				},
				yearlyIncome: {
					required
				},
				taxNumber: {
					required,
					pattern: pattern(TAX_NUMBER_REGEXP)
				},
				contactName: {
					required
				},
				contactMobilePhone: {
					required,
					pattern: pattern(MOBILE_PHONE_REGEXP)
				},
				contactEmail: {
					required,
					email
				},
				instrument: {
					required
				},
				captchaText: this.captchaImg
					? {
							required
					  }
					: {},
				acceptPrivacyStatement: {
					checked: value => value === true
				}
			}
		};
	},
	components: {
		VueButton,
		VueCaptcha,
		VueCheckbox,
		VueErrorMessage,
		VueInput,
		VueMaskedInput,
		VueMobilephoneInput,
		VueRadioGroup,
		VueSelect,
		VueSelectOption,
		VueSettlementSelector,
		VueTextarea,
		VueTooltip
	},
	methods: {
		focusButton() {
			this.$refs.button.$refs.button.focus();
		},
		send() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				this.focusButton();
				this.$emit('submit', this.model);
			}
		},
		async getSettlements(zipCode) {
			this.$emit('zip-change', zipCode);
		},
		resetCaptcha() {
			this.model.captchaText = null;
			this.$v.model.captchaText.$reset();
		}
	}
};
</script>

<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_colors.scss';
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.production-tool-contracting-form .page-subtitle {
	padding-left: 24px;
	padding-right: 24px;

	@include media('>=tablet') {
		padding-left: 60px;
		padding-right: 60px;
	}

	@include media('>=desktop') {
		padding-left: 84px;
		padding-right: 84px;
	}

	@include media('>=desktop-lg') {
		padding-left: 96px;
		padding-right: 96px;
	}
}

.production-tool-contracting-form .page-subtitle:not(:first-child) {
	padding-top: 16px;
}

.production-tool-contracting-form .sf-settlement-selector__single-result {
	font-weight: bold;
}

.production-tool-contracting-form hr {
	border-left: 0;
	border-right: 0;
	border-top: 0;
	height: 1px;
	margin-bottom: 32px;
	margin-left: 24px;
	margin-right: 24px;

	@include media('>=tablet') {
		margin-left: 60px;
		margin-right: 60px;
	}

	@include media('>=desktop') {
		margin-left: 84px;
		margin-right: 84px;
	}

	@include media('>=desktop-lg') {
		margin-left: 96px;
		margin-right: 96px;
	}
}

.production-tool-contracting-form .form-row .form-col .sf-checkbox {
	margin-bottom: 16px;
}
</style>
